import React from 'react'
import moment from 'moment'
import { getSentScheduledDate } from '../data'

const SentScheduledCell = ({ item, isMobile }) => {
  const dateVal = getSentScheduledDate(item)
  if (!dateVal) {
    return <span className="list-empty-dash">&mdash;</span>
  }
  if (isMobile) {
    return <span>{moment(dateVal).format('h:mma on MMM D, YYYY')}</span>
  }
  return (
    <span>
      <div>{moment(dateVal).format('h:mma on ')}</div>
      <div>{moment(dateVal).format('MMM D, YYYY')}</div>
    </span>
  )
}

export default SentScheduledCell
